/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { ExactStringUnionArray } from "helpers";
import { Permission } from "store/api/generatedApi.tsx";

export const PERMISSION_VALUES = [
  "review",
  "publish",
  "edit",
  "read",
  "review_mix",
  "video_labelling",
  "video_label_reviewing",
  "loading_edit_proposing",
  "manage_labellers",
  "crane_driver",
  "crane_supervisor",
  "crane_supervisor_viewer",
  "manage_overrides_catalog",
  "view_override_history",
  "edit_override_history",
  "plan_recipient",
  "scrap_tracking_dashboard_viewer",
  "scrap_eye_ingest",
  "scrap_eye_manager",
  "upload_file_write",
  "purchasing_admin",
  "analytics_admin",
  "strategy_dashboard_admin",
  "strategy_dashboard_inventory",
  "strategy_dashboard_consumption",
  "strategy_dashboard_production",
  "strategy_dashboard_quality",
  "strategy_dashboard_cost",
  "strategy_dashboard_prices",
  "strategy_dashboard_heats",
  "strategy_dashboard_scrap_chef_usage",
  "strategy_dashboard_deliveries",
  "strategy_dashboard_compliance",
  "strategy_dashboard_consumption_projection",
  "strategy_dashboard_editing",
  "strategy_dashboard_crew_comparison",
  "strategy_dashboard_schedule",
  "strategy_dashboard_savings",
  "delivery_form",
  "scenario_planning",
  "manage_target_baskets",
  "render_artefact",
  "clark_user",
  "read_clark_directory",
] as const;

export const CLARK_USER_PERMISSION = "clark_user" satisfies Permission;

export const PERMISSIONS_WITHOUT_TENANT_MEMBERSHIP: Permission[] = [
  CLARK_USER_PERMISSION,
  "read_clark_directory",
  "loading_edit_proposing",
];

type CheckPermissions = ExactStringUnionArray<
  typeof PERMISSION_VALUES,
  Permission
>;

// Force a type instantiation so that TypeScript will complain if there's a mismatch.
// If everything matches, `check` can be assigned `true` with no error.
// If not, you'll see the error message from `ExactStringUnionArray`.
const check: CheckPermissions = true;

if (!check) {
  // Unreachable code
  throw new Error("Permissions do not match.");
}
